import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getPurchaseApplicationAvailableColumns } from './api';

export const path = '/purchase-application/list';

const PagePurchaseAppliactionList: React.FC = (props) => {
  const PurchaseAppliactionList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getPurchaseApplicationAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <PurchaseAppliactionList {...props} />;
};

export default PagePurchaseAppliactionList;
